/**
 * Public procurement wins on the company page - the client half of
 * apps/api/src/modules/ariregister/lib/procurement/read.ts.
 */

/** One contract the company won, from the public procurement register's award notices. */
export interface ArProcurementWin {
  id: string;
  /** The award notice's date - a calendar date. */
  publishedAt: string | null;
  /** The register's procurement number, when the notice carried it in the
   *  register's own shape. */
  referenceNumber: string | null;
  title: string | null;
  /** The lot's own title, when the procurement was split into lots. */
  lotTitle: string | null;
  cpv: string | null;
  /** A framework agreement: the amount is its ceiling, not money paid. */
  framework: boolean;
  contractTitle: string | null;
  signedAt: string | null;
  /** The winning tender's value in cents, or null when the buyer withheld it.
   *  A consortium member carries the whole consortium's tender. */
  amountCents: number | null;
  currency: string | null;
  buyerName: string | null;
  buyerRegCode: string | null;
}

/**
 * The register's public page for a procurement.
 *
 * `#/procurement-ref/<number>` is the register's own public redirect from the
 * reference number to the procurement page (checked: 308990 lands on the
 * procurement it names). The internal id the page itself uses is not in the
 * award notice, so this is the only link the data can build.
 */
export function procurementPageUrl(referenceNumber: string): string {
  return `https://riigihanked.riik.ee/rhr-web/#/procurement-ref/${encodeURIComponent(referenceNumber)}`;
}
